import { TextProps } from "antd/es/typography/Text";
import { CSSProperties } from "react";
import { Typography } from "antd";
import useTheme from "../hooks/theme";
import React from "react";

interface Props extends Omit<TextProps, "type"> {
  align?: CSSProperties["textAlign"];
  color?: CSSProperties["color"];
  size?: CSSProperties["fontSize"];
  opacity?: CSSProperties["opacity"];
  weight?: CSSProperties["fontWeight"];
  lineHeight?: CSSProperties["lineHeight"];
  level?: number | "link" | "text";
  type?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "success"
    | "warning"
    | "error"
    | "disabled"
    | "base";
}

const Text: React.FC<Props> = ({
  level = 0,
  style,
  copyable,
  children,
  type,
  weight,
  color,
  size,
  opacity,
  align,
  lineHeight,
  underline,
  className,
  ...props
}) => {
  const theme = useTheme();
  const fontColor =
    color ||
    (type === "error" || type === "warning"
      ? theme.colors.font.destructive
      : theme.colors.font[type || "primary"]);
  const isTitle = [1, 2, 3, 4, 5].includes(level as number);
  const AntText = isTitle
    ? Typography.Title
    : level === "link"
    ? Typography.Link
    : level === "text"
    ? Typography.Text
    : Typography.Paragraph;

  const textStyle: CSSProperties = {
    margin: 0,
    opacity,
    fontSize: size,
    textAlign: align,
    fontWeight: weight,
    lineHeight: lineHeight ?? (isTitle ? undefined : "1.9rem"),
    color: fontColor,
    textDecoration: underline ? "underline" : undefined,
    ["--ui-text-color" as string]: fontColor,
    ...style,
  } as CSSProperties;

  if (copyable) {
    const antdType =
      type === "secondary" || type === "success" || type === "warning"
        ? type
        : undefined;
    return (
      <Typography.Text
        {...(props as any)}
        type={antdType}
        copyable={copyable}
        className={`ui-text ${className || ""}`}
        style={{
          margin: 0,
          fontWeight: weight,
          ["--ui-text-color" as string]: fontColor,
          ...style,
        }}
        children={children}
      />
    );
  }

  return (
    <AntText
      {...(props as any)}
      {...(isTitle ? { level } : {})}
      className={`ui-text ${className || ""}`}
      style={textStyle}
      children={children}
    />
  );
};

export default Text;
